// @flow
import {all, call, fork, put, takeEvery} from 'redux-saga/effects';

import {CHANGE_ACTIVE_MENU_FROM_LOCATION, INIT_MENU} from './constants';
import {authProtectedRoutes as routes} from '../../../../../routes';
import assignIds from './utils';
import {changeActiveMenuFromLocationSuccess, initMenuSuccess} from './actions';
import {equals, isNil} from 'ramda';
import {getLoggedInUser, hasPermission} from '../../../../../shared/authUtils';

function theLastPath(path): String {
    if (path) {
        const arr = path.split(/\//g)
        return arr[arr.length - 1].split('?')[0]
    } else {
        return ''
    }

}

/**
 * Activate menu items from location
 * @param {*} menuItems
 */
const getActivatedMenuItemIds = menuItems => {
    let matchingItems = [];
    const currentPath = window.location.hash;
    for (let menuItem of menuItems) {
        if (theLastPath(currentPath) === theLastPath(menuItem.path)) {
            matchingItems.push(menuItem.id);
        }

        if (typeof menuItem.children !== 'undefined') {
            matchingItems = [...matchingItems, ...getActivatedMenuItemIds(menuItem.children)];
        }
    }
    return matchingItems;
};

/**
 * Initilizes the menu
 */
function* initMenuAndItems() {
    try {
        const availableRoutes = routes.filter(route => isNil(route.permissions) || hasPermission(route.permissions));
        const user = getLoggedInUser();
        let menuItems = [];
        let activatedMenuItemIds = [];

        if (user && !equals(parseInt(user.permission), 0)) {
            menuItems = assignIds(availableRoutes);
            activatedMenuItemIds = yield call(getActivatedMenuItemIds, menuItems);
        }

        yield put(initMenuSuccess(menuItems));
        yield put(changeActiveMenuFromLocationSuccess(activatedMenuItemIds));
    } catch (error) {
    }
}

/**
 * change the active menu item based on location
 */
function* changeActiveMenuFromLocation() {
    try {
        const menuItems = assignIds(routes);
        const activatedMenuItemIds = yield call(getActivatedMenuItemIds, menuItems);
        yield put(changeActiveMenuFromLocationSuccess(activatedMenuItemIds));
    } catch (error) {
    }
}

/**
 * Watchers
 */
export function* watchMenuInit(): any {
    yield takeEvery(INIT_MENU, initMenuAndItems);
}

export function* watchMenuChange(): any {
    yield takeEvery(CHANGE_ACTIVE_MENU_FROM_LOCATION, changeActiveMenuFromLocation);
}

function* appMenuSaga(): any {
    yield all([fork(watchMenuInit), fork(watchMenuChange)]);
}

export default appMenuSaga;
